import React from 'react';
import T from 'prop-types';
import { Title } from '..';

export const ErrorText = ({ text }) => {
    return <Title className="errorTexCls" text={text} />;
};

ErrorText.propTypes = {
    text: T.string,
};

ErrorText.defaultProps = {
    text: '',
};
